<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="part">
<div epub:type="bodymatter">
<section epub:type="division">
<h1 class="part_num"><a id="page21"></a><a id="page22"></a><img alt="" src="Images/logo1.jpg"/> <strong>PART I</strong> <img alt="" src="Images/logo2.jpg"/></h1>
<h1 class="part_title"><strong>PEOPLE AND THINGS</strong></h1>
<div class="part_opner">
<p class="part_opner_text"><em>“Never before have the achievements of the industrial arts, the fine arts, and the sciences generally, shone with such lustre as gilds this epoch of the nineteenth century.”</em></p>
<p class="part_opner_author"><span class="textsmall">—J. S. INGRAM, <em>THE CENTENNIAL EXPOSITION, DESCRIBED AND ILLUSTRATED</em> (1876)<sup><span href="#/Text/9781454925767_epub_nts_r1#p01_fnt1" id="p01_fnt1a" title="Link target outside of Sample">1</span></sup></span></p>
</div>
<div class="dis_img" id="fig22"><img alt="" src="Images/22-1.jpg"/>
<p class="caption">The cover of Frank Leslie’s Illustrated historical register of the Centennial Exposition of 1876. Columbia, goddess of Liberty (symbolizing America in red, white, and blue) reveals to figures representing Europe, Asia, and Africa (plus a submissively kneeling Native American) the wonders of American industry, commerce, and government, on display at the exposition.</p>
</div>
</section>
</div>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781454925767_epub_p01_r1.vue?1971041c